export const SCHOOL = {
  name: 'Universal Kempo Karate',
  locationLabel: 'Revolution — Colorado Springs',
  address: '2380 Montebello Dr. W, Colorado Springs, CO 80918',
  founded: 1980,
  directionsUrl: 'https://www.google.com/maps/dir/?api=1&destination=2380+Montebello+Dr+W+Colorado+Springs+CO+80918',
  mapsViewUrl: 'https://www.google.com/maps/search/?api=1&query=2380+Montebello+Dr+W+Colorado+Springs+CO+80918',
  phone: '(719) 896-0593',
  phoneHref: 'tel:+17198960593',
  smsHref: 'sms:+17198960593',
  contactName: 'Bridget Johnson',
  reviewLinkUrl: 'https://www.google.com/search?q=Universal+Kempo+Karate+Colorado+Springs+reviews',
  hours: [
    { day: 'Tuesday', hours: '4:30 PM – 8:00 PM' },
    { day: 'Thursday', hours: '4:30 PM – 8:00 PM' },
    { day: 'Mon / Wed / Fri / Sat / Sun', hours: 'Closed' },
  ],
};

export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_314e0372-4394-4228-b1d6-7dd75615009a/artifacts/ie6smq8s_kempo_patch_HQ_large.png';

export const GALLERY = [
  {
    id: 'g1',
    url: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/pfzgm9ik_512675824_10235902812338064_8932337036377279083_n.jpeg',
    caption: 'Stadium demo — Kempo Kids, Colorado Springs',
    span: 'lg:col-span-8 lg:row-span-2',
    focus: 'center 35%',
  },
  {
    id: 'g2',
    url: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/bibmwhzu_499882273_30146878024903617_3662007970466396908_n.jpeg',
    caption: 'Belt ceremony — earned, not given',
    span: 'lg:col-span-4',
    focus: 'center 30%',
  },
  {
    id: 'g3',
    url: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/zkp7nckp_649103254_10239329837611554_3698230986073007284_n.jpeg',
    caption: 'The Universal Kempo family',
    span: 'lg:col-span-4',
    focus: 'center 40%',
  },
  {
    id: 'g4',
    url: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/jep1mog3_513826107_10235910162761820_6628217572269810338_n.jpeg',
    caption: 'Live demonstration — discipline on stage',
    span: 'lg:col-span-5 lg:row-span-2',
    focus: 'center 35%',
  },
  {
    id: 'g5',
    url: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/vymvn7p3_651240555_10239509706508164_2923840365154232931_n.jpeg',
    caption: 'Adult class — every age, every level',
    span: 'lg:col-span-7 lg:row-span-2',
    focus: 'center 40%',
  },
];

export const PROGRAMS = [
  {
    id: 'little-dragons',
    name: 'Little Dragons',
    ages: 'Ages 4 – 6',
    summary: 'Big-energy fundamentals, focus games, listening, and the first real karate skills — packaged for the youngest warriors.',
    bullets: ['Confidence + listening', 'Coordination & balance', 'Respectful mat behavior'],
    testid: 'program-card-little-dragons',
    photo: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/h78g9wha_1.jpeg',
  },
  {
    id: 'kids',
    name: 'Kids Martial Arts',
    ages: 'Ages 7 – 12',
    summary: 'The flagship kids program. Real Kempo techniques, character development, anti-bully self-defense and progressive belt ranks.',
    bullets: ['Striking, blocks & flow drills', 'Bully-defense scenarios', 'Belt progression (White → Black)'],
    testid: 'program-card-kids',
    photo: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/d0pvn07q_2.jpeg',
  },
  {
    id: 'teens',
    name: 'Teen Martial Arts',
    ages: 'Ages 13 – 17',
    summary: 'Sharper technique, real-world self-defense, and the discipline that turns good teens into leaders on and off the mat.',
    bullets: ['Pressure-tested self-defense', 'Confidence & leadership', 'Tournaments & demos (optional)'],
    testid: 'program-card-teens',
    photo: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/1tz65hu0_3.jpeg',
  },
  {
    id: 'adult',
    name: 'Adult Martial Arts',
    ages: 'Adults — All Levels',
    summary: 'Sharp, real-world self-defense + serious fitness. Stress relief that hits back. No experience required — ever.',
    bullets: ['Self-defense for real life', 'Strength, conditioning & focus', 'Beginner-friendly, lifelong path'],
    testid: 'program-card-adult',
    photo: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/5m2giynl_4.jpeg',
  },
];

export const TEAM = [
  {
    id: 'professor-johnson',
    name: 'Professor Johnson',
    role: 'Founder & Chief Instructor',
    bio: 'Veteran-led, family-rooted. Professor Johnson founded Universal Kempo Karate in 1980 and has shaped generations of Colorado Springs warriors with the Mind-Body-Spirit code.',
    initials: 'PJ',
    photo: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/uvafnvrj_IMG_3471.jpeg',
  },
  {
    id: 'mrs-johnson',
    name: 'Mrs. Johnson',
    role: 'Co-Founder & Family Liaison',
    bio: 'The heart of the school. Mrs. Johnson keeps the karate school a safe, family-first space — patient, positive, and known for making every new student feel at home.',
    initials: 'MJ',
    photo: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/vk84zgoy_58769437_2752076371500254_4514086429973807104_n.jpeg',
  },
  {
    id: 'andre-johnson',
    name: 'Andre Johnson',
    role: 'Chief Instructor · 4th Degree Black Belt',
    bio: 'A 4th Degree Black Belt who has trained in Kempo since age three. Gold-medal competitor in sparring, weapons, and forms — now shaping the next generation of Colorado Springs warriors with the same discipline that raised him.',
    initials: 'AJ',
    photo: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_kempo-patch/artifacts/3f5lijfp_IMG_4985.jpeg',
  },
];

export const BELT_RANKS = [
  { name: 'White', color: '#FFFFFF', desc: 'The beginning. Pure potential.' },
  { name: 'Yellow', color: '#F7D000', desc: 'First light. The basics take root.' },
  { name: 'Orange', color: '#FF8A00', desc: 'Warmth and persistence build.' },
  { name: 'Purple', color: '#7A2BFF', desc: 'Depth. Pressure-testing begins.' },
  { name: 'Blue', color: '#1E90FF', desc: 'Sky. Higher expectations, sharper form.' },
  { name: 'Green', color: '#22C55E', desc: 'Growth. Self-defense becomes instinct.' },
  { name: 'Brown 3rd', color: '#8B4513', desc: 'Senior student. Mentorship begins.' },
  { name: 'Brown 2nd', color: '#7A3D11', desc: 'Refining everything that came before.' },
  { name: 'Brown 1st', color: '#693410', desc: 'On the doorstep of Black.' },
  { name: 'Black Belt', color: '#0A0A0A', desc: 'Not the end. The real beginning.' },
  { name: 'Dan Ranks', color: '#0A0A0A', desc: '1st degree and beyond — lifelong mastery.' },
];

export const KEMPO_HISTORY = [
  {
    era: 'Origins',
    body: 'Kempo — also spelled Kenpo — traces back to ancient Chinese martial arts that traveled through Okinawa and Japan over centuries. The word itself means \"Fist Law\" or \"Way of the Fist.\"',
  },
  {
    era: 'The Art',
    body: 'Kempo blends striking (hands, elbows, knees, kicks), grappling, joint locks, and self-defense flow drills. It rewards adaptability over rigidity — a fighter\u2019s art tempered by a scholar\u2019s discipline.',
  },
  {
    era: 'American Kempo',
    body: 'In the mid-20th century, American Kempo Karate evolved with an emphasis on real-world self-defense and the harmony of Mind, Body, and Spirit — the three pillars on our patch.',
  },
  {
    era: 'Universal Kempo (1980 — Today)',
    body: 'Universal Kempo Karate has carried this lineage in Colorado Springs since 1980. Veteran-founded, family-run, and now welcoming new students at our Revolution location on Montebello.',
  },
];
